








































import Vue from 'vue';
import UploadControl from "@/componentsReusable/UploadControl.vue";
import {ImportLeads} from "@/components/providers/models/ImportLeadsInterface";
import {importLeads} from "@/components/providers/services/ImportProvidersService";
import {BallPulseLoader} from "vue-loaders";
import OwnerSelector, {Owner} from '@/componentsReusable/OwnerSelector.vue';

export default Vue.component('provider-modal', {
  name: 'ImportModal',
  data() {
    return {
      isImportingData: false,
      importLeads: {} as ImportLeads,
      errors: [] as string[],
      owner: ''
    }
  },
  props: {
    providerId: {
      type: Number,
      required: false
    },
  },
  components: {
    UploadControl,
    BallPulseLoader,
    OwnerSelector
  },
  computed: {
    ownerName(): string {
      return this.owner || 'select';
    }
  },
  created() {
    this.importLeads.s3FilePath = '';
    this.importLeads.fileName = '';
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async importData() {
      this.isImportingData = true;

      this.errors = [];
      if (this.importLeads.s3FilePath === '' || this.importLeads.fileName === '') {
        this.errors.push('Please upload a file first.');
      }
      if (!this.importLeads.ownerId) {
        this.errors.push('Please select an owner.');
      }

      try {
        if (!this.errors.length) {
          const result = await importLeads(this.importLeads);
          this.$emit('close');
          this.$emit('complete', result.message);
        }
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error importing leads',
          text: `Error: ${err}`,
        });
      }
      this.isImportingData = false;
    },
    async setUpFileForImport(s3FilePath: string, id: string, fileName: string) {
      this.importLeads.fileName = fileName;
      this.importLeads.s3FilePath = s3FilePath;
      this.importLeads = Object.assign({}, this.importLeads, {fileName: fileName});
    },
    ownerSelected(owner: Owner) {
      this.owner = owner.fullName;
      this.importLeads.ownerId = owner.id;
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/providers/ImportModal.vue